import React from "react";
import styled from "styled-components";

const Principal = styled.span`
  font-size: 32px;
  padding: 0;
  font-weight: bold;
  font-family: Roboto;
`;
const Nombre = styled.span`
  font-size: 24px;
  padding: 0;
  font-weight: normal;
  font-family: Roboto;
  margin-left:8px;
`;
const Detalle = styled.span`
  font-size: 18px;
  padding: 0;
  font-weight: normal;
  font-family: Roboto;
  margin-left:8px;
`;
function Titulo (props){
  return (
    <>
      <Principal>
        {props.tipo} | 
        <Nombre>
          {props.nombre} {props.showDetalle?"|":""}
        </Nombre>
        {
          props.showDetalle?(
            <Detalle>
                Detalle por {props.filtro}
            </Detalle>
          ):(
            <></>
          )
        }
       
      </Principal>
      
    </>
  );
}

export default Titulo;